import { twoDecimalPercentFormat } from 'common/formats/formats';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { FundInvestmentMarketAdjustmentCellData } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet';
import { getStringValue } from 'utilities';
import { removeClassName } from 'utilities/classNameHandlers';

const normalizePercentageCell = (cell: ICell<FundInvestmentMarketAdjustmentCellData>): void => {
  Object.assign(cell, {
    className: `${removeClassName(getStringValue(cell.className), 'left-aligned')} right-aligned`,
    format: twoDecimalPercentFormat({ validateFloat: true }),
    gridType: 'percentage',
    hidden: false,
  });
};

export default normalizePercentageCell;
